import type { FaireProductEntity } from "../../entity_types/product";

export const p_d9hxbqhx5z: FaireProductEntity = {
  token: "p_d9hxbqhx5z",
  type: "product",
  name: "The Warrior Women of Islam: Female Empowerment in Arabic Popular Literature - Paperback",
  brandName: "Upscaling Demo Brand",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/013296d68a5e39b80e19762734edbadbaf010937f3dd1fd01c201d929d394b5b.jpeg",
  afterImageUrl:
    "https://cdn.prerelease.faire.dev/fastly/a3cd605bfd49e4badce5761073e889cc76390453a1cac628d4e28c7a07223e8d.jpeg",
  priceDollars: 24,
  description: "Image upscaling comparison product.",
  categoryTokens: ["cat_proto_image-upscaling"],
  tags: ["upscaling"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
